import { motion } from "framer-motion";
import { MapPinned, ExternalLink } from "lucide-react";

const Tourisme = () => {
  return (
    <section data-testid="tourisme-section" id="tourisme" className="py-16 lg:py-20 bg-creme">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rounded-[2rem] bg-sable border border-border p-8 lg:p-10 flex flex-col md:flex-row md:items-center gap-6"
        >
          <div className="w-16 h-16 rounded-2xl bg-bordeaux/10 text-bordeaux flex items-center justify-center shrink-0">
            <MapPinned size={30} />
          </div>
          <div className="flex-1">
            <span className="text-sm uppercase tracking-[0.3em] text-mousse font-500">Notre partenaire tourisme</span>
            <h3 className="font-heading text-2xl sm:text-3xl text-foreground mt-1">
              Office de Tourisme Sud Côte Chalonnaise
            </h3>
            <p className="text-foreground/75 mt-2 leading-relaxed">
              Fiers d'être soutenus par l'Office de Tourisme de la Communauté de Communes Sud Côte
              Chalonnaise. Retrouvez-nous parmi les bonnes adresses de l'appli web
              <strong className="text-foreground"> Route71 — Bourgogne du Sud</strong>.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row md:flex-col gap-3 shrink-0">
            <a
              href="https://www.tourisme-sud-cote-chalonnaise.com"
              target="_blank"
              rel="noreferrer"
              data-testid="office-tourisme-link"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-bordeaux text-bordeaux font-600 px-6 py-3 whitespace-nowrap hover:bg-bordeaux hover:text-white transition-all"
            >
              Office de Tourisme <ExternalLink size={16} />
            </a>
            <a
              href="https://route71.fr"
              target="_blank"
              rel="noreferrer"
              data-testid="route71-link"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-bordeaux text-white font-600 px-6 py-3 whitespace-nowrap hover:bg-bordeaux-dark transition-all hover:-translate-y-0.5"
            >
              Découvrir Route71 <ExternalLink size={16} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Tourisme;
